import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import FuncionarioService from '../../../services/funcionarios';
import Holerite from './holerite';
import Busca from './busca';
import '../../../styles/diario.scss';


const HoleritesScreen = () => {

    const [holerites, setHolerites] = useState([]);
    const [holeritesOriginais, setHoleritesOriginais] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
    const [anosDisponiveis, setAnosDisponiveis] = useState([]);
    const func = JSON.parse(localStorage.getItem('funcionario'))


    async function fetchHolerites() {
        var funcId = func._id
        const response = await FuncionarioService.holerites(funcId);
        if (response.data["holerites"].length >= 1) {

            const lista = response.data["holerites"];

            setHolerites(lista);
            setHoleritesOriginais(lista);

            // obtém meses únicos
            const meses = [...new Set(lista.map(h => h.mes))].sort((a, b) => a - b);
            setMesesDisponiveis(meses);

            // obtém anos únicos
            const anos = [...new Set(lista.map(h => h.ano))].sort((a, b) => a - b);
            setAnosDisponiveis(anos);

            setVazio(false);

        } else {
            setHolerites([]);
            setHoleritesOriginais([]);
            setMesesDisponiveis([]);
            setAnosDisponiveis([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (mes, ano) => {
        let filtrados = holeritesOriginais;

        if (mes) filtrados = filtrados.filter(h => h.mes == mes);
        if (ano) filtrados = filtrados.filter(h => h.ano == ano);

        if (filtrados.length >= 1) {
            setHolerites(filtrados);
            setVazio(false);
        } else {
            setHolerites([]);
            setVazio(true);
        }
    };

    useEffect(() => {
        fetchHolerites();
    }, []);


    return (
        <Fragment>
            <Container>
                <Fragment>
                    <Busca
                        meses={mesesDisponiveis}
                        anos={anosDisponiveis}
                        filtrarLocalmente={filtrarLocalmente}
                        reset={() => { setHolerites(holeritesOriginais); setVazio(false); }}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Não localizamos nenhuma holerite referente ao período :(</Alert>
                </Fragment> :
                    <Fragment>
                        <br/>
                        <Table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Mês/Ano</th>
                                    <th>Holerite</th>
                                </tr>
                            </thead>
                            <tbody>
                                {holerites.map((holerite, index) =>
                                    <Holerite
                                        holerite={holerite}
                                        key={index}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Fragment>}
            </Container>
        </Fragment>

    )
}

export default HoleritesScreen;